import React, { useState } from "react";
import { useFetchData } from "../../hooks/useFetchData";
import Developercard from "../../ui/Developercard";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

const Developerpage = () => {
  const [selected, setSelected] = useState();

  const { data } = useFetchData(
    "https://3dfinal.tanaghomtech.com/public/api/developers"
  );
  console.log("developer", data);

  return (
    <div
      className="container-fluid"
      style={{
        background: "#d4d4d4",
        flexGrow: 1,
        background:
          "linear-gradient(0deg, rgba(212, 212, 212, 1) 0%, rgba(255, 255, 255, 1) 100%)",
      }}
    >
      <Grid container spacing={3}>
        {data?.data?.map((item, index) => (
          <Grid size={{ xs: 12, md: 4 }}>
            <Developercard
              key={index}
              i={item}
              setSelected={setSelected}
              selected={selected}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Developerpage;
